import{BeanMonitoria} from './BeanMonitoria'
import{BeanFormulario} from './BeanFormulario'


export class BeanUtilMoniForm{
  constructor(
    public beanMonitoria : BeanMonitoria,
    public beanFormulario  : BeanFormulario
  ){}
}